import { useState } from 'react';

import { EdgeStack } from '@/react/edge/edge-stacks/types';
import { GitReferenceCard } from '@/react/portainer/gitops/GitReferenceCard/GitReferenceCard';
import { isWorkflowManagedStack } from '@/react/common/stacks/isWorkflowManagedStack';

import { Widget } from '@@/Widget';

import { HelmGitForm } from './GitForm/GitForm';
import { HelmRepositoryEditForm } from './HelmRepositoryEditForm';
import { NonGitStackForm } from './NonGitStackForm';

export function EditEdgeStackForm({ edgeStack }: { edgeStack: EdgeStack }) {
  const [hasGitReferenceError, setHasGitReferenceError] = useState(false);

  if (isWorkflowManagedStack(edgeStack)) {
    const isHelmDeployment = !!edgeStack.HelmConfig;

    return (
      <div className="mx-4 space-y-4">
        <GitReferenceCard
          stackType={isHelmDeployment ? 'edge-helm' : 'edge'}
          autoUpdate={edgeStack.AutoUpdate}
          currentDeploymentInfo={edgeStack.CurrentDeploymentInfo}
          stackId={edgeStack.Id}
          onErrorChange={setHasGitReferenceError}
          workflowId={edgeStack.WorkflowID}
        />

        {isHelmDeployment && (
          <Widget>
            <Widget.Body>
              <HelmGitForm
                stack={edgeStack}
                hasGitReferenceError={hasGitReferenceError}
              />
            </Widget.Body>
          </Widget>
        )}
      </div>
    );
  }

  if (edgeStack.HelmConfig?.ChartURL) {
    return (
      <div className="mx-4">
        <Widget>
          <Widget.Body>
            <HelmRepositoryEditForm edgeStack={edgeStack} />
          </Widget.Body>
        </Widget>
      </div>
    );
  }

  return (
    <div className="mx-4">
      <Widget>
        <Widget.Body>
          <NonGitStackForm edgeStack={edgeStack} />
        </Widget.Body>
      </Widget>
    </div>
  );
}
